import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { GatsbyImage } from 'gatsby-plugin-image';
import { getBusinessValues } from '../../common/webSiteVariables';
import { findImage } from '../../common/imageLoader';

import './why.key.less';

const Key = () => {
  const { t } = useTranslation();
  const { countries, partners, loans, business } = getBusinessValues();
  return (
    <div className="o-whyKey">
      <GatsbyImage
        image={findImage('key_indicators')}
        className="a-whyKey__img"
        alt={t('images.key.indicators.alt')}
        title={t('images.key.indicators.title')}
      />
      <div className="m-globalContentContainer">
        <div className="m-whyKey__content">
          <h1 className="a-whyKey__h3 a-whyKey__mainTitle -page-title -centered">
            {t('web.why.key.title')}
          </h1>
          <div className="m-whyKey__keysContent">
            <div className="m-whyKey__inContent">
              <h2 className="a-whyKey__h3">{business}</h2>
              <p className="a-whyKey__p">{t('web.why.key.business')}</p>
            </div>
            <div className="m-whyKey__inContent">
              <h2 className="a-whyKey__h3">{loans}</h2>
              <p className="a-whyKey__p">{t('web.why.key.loans')}</p>
            </div>
            <div className="m-whyKey__inContent">
              <h2 className="a-whyKey__h3">{partners}</h2>
              <p className="a-whyKey__p">{t('web.why.key.partners')}</p>
            </div>
            <div className="m-whyKey__inContent">
              <h2 className="a-whyKey__h3">{countries}</h2>
              <p className="a-whyKey__p">{t('web.why.key.country.presence')}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Key;
